export const dataHooks = {
    timelineListEvent: 'timeline-list-event',
    timelineLabel: 'timeline-label',
    timelineTextSuffix: 'timeline-text-suffix',
    timelineSuffix: 'timeline-suffix',
    timelineDefaultPrefix: 'timeline-default-prefix',
    timelineBulletIndicator: 'timeline-bullet-indicator',
    timelineLabelAction: 'timeline-label-action',
};
//# sourceMappingURL=constants.js.map